<template>
  <footer
    v-if="customizations"
    style="background-color: #f4f5f5; padding: 24px; margin-top: 24px"
  >
    <div
      class="d-flex align-items-center justify-content-cFenter flex-wrap flex-column"
      style="
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 0px;
      "
    >
      <div class="whitespace-nowrap">For any questions:</div>
      <div class="d-flex align-items-center">
        <div class="mr-3 whitespace-nowrap">
          <b>{{ tenantPhone }}</b>
        </div>
        <Divider vertical />
        <div class="whitespace-nowrap">
          <a
            class="ml-1 text-primary"
            :href="`mailto:${customizations.Tenant.support_email}`"
            target="_blank"
          >
            Email Us
          </a>
        </div>
      </div>
      <div
        v-if="checkPayableTo"
        class="whitespace-nowrap"
        style="margin-top: 8px"
      >
        Check Payable To: <b>{{ checkPayableTo }}</b>
      </div>
    </div>

    <Divider />

    <p style="font-size: 12px; font-weight: 400; line-height: 20px">
      <span
        style="white-space: pre-line; word-break: break-word"
        v-html="emailLicenceInfo"
      />
    </p>

    <Divider />

    <p
      v-if="emailTermsText"
      style="font-size: 12px; font-weight: 400; line-height: 20px"
    >
      <span
        style="white-space: pre-line; word-break: break-word"
        v-html="emailTermsText"
      />
    </p>
  </footer>
</template>

<script lang="ts">
import Divider from "serviceshift-ui/components/General/Divider.vue";

import { Customizations } from "@/typings/customizations";

export default {
  components: {
    Divider
  },
  props: {
    customizations: {
      type: Object as () => Customizations,
      default: null
    }
  },
  computed: {
    checkPayableTo() {
      const payableTo = this.customizations.General.check_payable_to;
      if (!payableTo) return "";
      return payableTo.value || payableTo.default;
    },
    emailTermsText() {
      const termsText = this.customizations.General.email_terms_of_service;
      if (!termsText) return "";
      return termsText.value || termsText.default;
    },
    emailLicenceInfo() {
      const licenceInfo = this.customizations.General.email_license_information;
      if (!licenceInfo) return "";
      return licenceInfo.value || licenceInfo.default;
    },
    tenantPhone() {
      const { phone } = this.customizations.General;
      return phone.value || phone.default;
    }
  }
};
</script>

<style lang="scss" scoped>
.divider {
  height: 1px;
  max-height: 1px;
  width: 100%;
  background-color: var(--separator-gray);
  margin: 0.5rem 0;
}

.footer-info-container {
  display: flex;
  flex-direction: row;
  font-size: 13px;
  padding: 1rem;
}

.tenant-info {
  width: 25%;
  white-space: pre-line;
  border-right: 1px solid var(--separator-gray);
  margin-right: 1rem;
}

.email-terms {
  width: 75%;
}

.tenant-name {
  font-weight: bold;
}

.support-info {
  text-align: center;
  font-size: 13px;
}

.footer {
  margin-bottom: 3rem;
}
</style>
